import React from "react";

const SelectedIcon = () => (
  <svg 
    width="20" 
    height="20" 
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm0 2a10 10 0 1 1 0-20 10 10 0 0 1 0 20z"
      fill="#F15A23"
      fillRule="evenodd"
    />
    <circle cx="10" cy="10" r="4" fill="#F15A23" />
  </svg>
);

export default SelectedIcon;
